import {useEffect, useState} from 'react';
import {NsGrid} from '@/components/GridWidget/GridDefProps';
import {WdiCardTitle, wdiCore} from '@/components/WdiControls';
import {WdiPanel} from '@/components/WdiControls/WdiPanel';
import {Enum} from '@/enums/system';
import {GridApi} from '@/services/gridapi';
import {DetailGrid} from '@/components/GridWidget';

type ProjectBudgetInfoProps = {
  dataSource: any[],
};
export const ProjectBudgetInfoPanel: React.FC<ProjectBudgetInfoProps> = (props) => {
  /// Grid初始化配置，GridSettings请求完数据之后再进行加载
  const [isLoaded, setIsLoaded] = useState(false);
  const [gridSettings, setGridSettings] = useState<any>({});

  const {dataSource} = props;

  useEffect(() => {
    GridApi.searchConfig({id: 'ProjectBudgetInfo', allowModifyColumns: true}).then((response) => {
      const settings: any = Object.assign({}, response.data, {
        actionsAlign: NsGrid.ActionsAlign.None,
      });

      settings.formSchema.allFields.amountRemain.getDisplayFormater = (text: any, record: any, index: any) => {
        if(record.amountRemain<=0){
          return <span style={{color:'red'}}>{wdiCore.Number.AmountToString(record.amountRemain)}</span>;
        }
        return wdiCore.Number.AmountToString(record.amountRemain)
      }
      settings.formSchema.allFields.productId.getDisplayFormater=(text: any, record: any, index: any) => {
        return wdiCore.String.CodeOrName(record.productCode,record.productName)
      }

      setGridSettings(settings);
      setIsLoaded(true);
    });
  }, []);
  const pageGridSettings = Object.assign({}, gridSettings);
  pageGridSettings.antdProps = {
    dataSource,
    pagination: {
      defaultPageSize: 10,
      showSizeChanger: true
    }
  };

  return (
    <WdiPanel title={<WdiCardTitle iconType={Enum.IconType.DETAIL_COUNT_INFO} title='专项预算信息'/>} collapsed={true}>
      {isLoaded && (
        <DetailGrid {...pageGridSettings} />
      )}
    </WdiPanel>
  );
};

export default ProjectBudgetInfoPanel;


